export default __webpack_public_path__ + "static/media/i010vp.0faa0ba2.webp";